import React, { useEffect } from 'react';
import ReactDOM from 'react-dom/client';
import { Capacitor } from '@capacitor/core';
import './index.css';
import './styles/dialogs.css';
import './styles/items.css';
import './styles/navigation.css';
import './styles/pages.css';
import './styles/player.css';
import './styles/views.css';
import './styles/mui.css';
import App from './App';
import TR from './Trans';
import muvikaAttrs from './attrs';
import SongbookApp from './components/pages/SongbookApp';
import SongbookLogin from './components/pages/SongbookLogin';
import { HashRouter, BrowserRouter, Routes, Route } from "react-router-dom";
import reportWebVitals from './reportWebVitals';
import TestService from './services/testing';
import MuvikaService from './services/muvika';
import IntervalService from './services/intervals';
import sessionStore from './stores/session';
import songbookSessionStore from './stores/songbookSession';
import statusStore from './stores/status';
import playerStore from './stores/player';
import musicPlayerStore from './stores/musicPlayer';
import messageStore from './stores/message';
import navigationStore from './stores/navigation';
import settingsStore from './stores/settings'
import { SafeArea } from 'capacitor-plugin-safe-area';
import { lockOrientation } from './services/screen';
import { SplashScreen } from '@capacitor/splash-screen';
import { AndroidExternalScreen } from 'muvika-android-external-screen';
import { Chromecast } from '@gameleap/capacitor-chromecast';
import { AppleStoreKitExternalLinkAccount } from '@kokotree-inc/capacitor-plugin-apple-storekit-external-link-account';
import { generateId } from './services/random';
import { saveSystemData, isSystemDataSet } from './services/systemData';
import { EdgeToEdge } from '@capawesome/capacitor-android-edge-to-edge-support'
import { initStorageSync } from './services/storageSync'
import VolumeControl from 'muvika-ios-volume-control';
import IosVolumeControl from './services/volume';
import { App as CapApp } from '@capacitor/app';
import version from './version';

//localStorage.clear();
await initStorageSync()

saveSystemData();

window.console.log = () => {
};

/* let tabId = generateId(12);
sessionStorage.setItem(muvikaAttrs.service+"-tab-id", JSON.stringify(tabId));
localStorage.setItem(muvikaAttrs.service+"-tab-current", JSON.stringify(tabId));

window.addEventListener("storage", (event) => {
    
    
  const cachedSession = localStorage.getItem(muvikaAttrs.service+"-storage");
  const sessionValue = JSON.parse(cachedSession);
  const savedTabId = sessionStorage.getItem(muvikaAttrs.service+"-tab-id");
  const savedTabIdValue = JSON.parse(savedTabId);
  const savedCurrentTabId = localStorage.getItem(muvikaAttrs.service+"-tab-current");
  const savedCurrentTabIdValue = JSON.parse(savedCurrentTabId);
  if (sessionValue && savedCurrentTabIdValue && savedTabIdValue) {
    if (savedCurrentTabIdValue !== savedTabIdValue) {
      const idleTab = 12345678999;
      sessionStore.getState().setThrownOut(true);
      messageStore.getState().setError(sessionValue.state.sessionToken, idleTab, TR.cm_another_tab);
    }
  }
}); */

const updateSessionIfNew = () => {

  const savedLang = localStorage.getItem(muvikaAttrs.service + "-session-language");
  const savedLangValue = JSON.parse(savedLang);
  const cachedSession = localStorage.getItem(muvikaAttrs.service + "-storage");
  const sessionValue = JSON.parse(cachedSession);
  if (sessionValue && savedLangValue) {
    if (sessionValue.state.isSessionOpen) {
      MuvikaService.updateSession(sessionValue.state.sessionToken, savedLangValue, true)
        .then(function (res) {
        })
        .catch(function () { });
    }
  }
};

const updateSongbookSessionIfNew = () => {

  const savedLang = localStorage.getItem(muvikaAttrs.service + "-session-language");
  const savedLangValue = JSON.parse(savedLang);
  const cachedSession = localStorage.getItem(muvikaAttrs.service + "-songbook-storage");
  const sessionValue = JSON.parse(cachedSession);
  if (sessionValue && savedLangValue) {
    if (sessionValue.state.isSessionOpen) {
      MuvikaService.updateSession(sessionValue.state.sessionToken, savedLangValue, true)
        .then(function (res) {
          if (res.data.error.code === 2004) {
            sessionStore.getState().reset();
          }
        })
        .catch(function () { });
    }
  }
};

console.log("karaoke app started");

updateSessionIfNew();
updateSongbookSessionIfNew();
lockOrientation();

const statusReportTime = 2 * 60 * 1000;

window.TestService = TestService;

sessionStore.getState().setThrownOut(false);

const initStatusReportInterval = () => {

  let statusReportInterval = setInterval(() => {
    let isSessionOpen = sessionStore.getState().isSessionOpen;
    //if(isSessionOpen){
    let sessionToken = sessionStore.getState().sessionToken;
    statusStore.getState().sendStatusReport(sessionToken);
    // }
  }, statusReportTime);
  IntervalService.setStatusReportInterval(statusReportInterval);
};

initStatusReportInterval();

await SplashScreen.hide();

if (!(Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'android')) {
  await SplashScreen.show({
    showDuration: 2000,
    autoHide: true,
  });
}

const GA_ID = 'AW-954266490';

const RouterWrapper = () => {
  const location = window.location.pathname;

  const isSpecialPage = location.endsWith('/songs') || location.endsWith('/songs/');

  console.log("location", location, isSpecialPage);

  useEffect(() => {
    if (!Capacitor.isNativePlatform()) {
      const script = document.createElement('script');
      script.src = `https://www.googletagmanager.com/gtag/js?id=`+muvikaAttrs.gaID;
      script.async = true;
      document.head.appendChild(script);

      script.onload = () => {
        window.dataLayer = window.dataLayer || [];
        function gtag() { window.dataLayer.push(arguments); }
        window.gtag = gtag;

        gtag('js', new Date());
        gtag('config', muvikaAttrs.gaID);
      };
    }
  }, []);


  if (isSpecialPage) {
    return (
      <BrowserRouter>
        <Routes>
          <Route path="*" element={<SongbookLogin />} />
        </Routes>
      </BrowserRouter>
    );
  }

  // Everything else uses HashRouter
  return <App isProd={true} />;
};

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <RouterWrapper />
);


// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();

let volumeWatcher = null;

let startListeningVolume = async () => {
  console.log("listen to volume")
  if (Capacitor.isNativePlatform() && Capacitor.getPlatform() === 'ios') {
    if (!volumeWatcher) {
      VolumeControl.watchVolume({ disableSystemVolumeHandler: false }, async (result, err) => {
        console.log("listen to volume: success")
        console.log("progChangeVolume", navigationStore.getState().progChangeVolume, err)
        if (!IntervalService.isFadingIn() && !IntervalService.isFadingOut()) {
          console.log("Volume event listener")
          navigationStore.getState().setUserVolumeFlag(false);
          let currentVolume = await IosVolumeControl.getDeviceVolume();
          console.log("Volume changed:", currentVolume, navigationStore.getState().isProgrammaticallyChanginVolume);
          if (!musicPlayerStore.getState().isMusicReallyPaused.isPaused) {
            musicPlayerStore.getState().setVolume(currentVolume, true);
            if (settingsStore.getState().settings) {
              let newSettings = { ...settingsStore.getState().settings };
              newSettings.music_volume = Math.round(currentVolume * 100);
              settingsStore.getState().setSettings(sessionStore.getState().sessionToken, newSettings, false);
            }
          } else {
            playerStore.getState().setVolume(currentVolume, true);
            if (settingsStore.getState().settings) {
              let newSettings = { ...settingsStore.getState().settings };
              newSettings.volume = Math.round(currentVolume * 100);
              settingsStore.getState().setSettings(sessionStore.getState().sessionToken, newSettings, false);
            }
          }
        }
      });
      volumeWatcher=1;
    }
  }
};

startListeningVolume();